import Divider from "@mui/material/Divider";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import { ClickAwayListener } from "@mui/base";
import {
  StyledAvatar,
  StyledButton,
  StyledPaper,
  StyledText,
  StyledNoHoverMenuItem,
  CircleWrapper,
  NotificationCircle,
} from "./SettingsDropDown.styles";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Style } from "@mui/icons-material";
import { Fragment, useEffect } from "react";
import { updateNotificationStatus } from "apis/MemoServiceApi";
import { set } from "date-fns";

export function NotificationPanel({
  openNotificationPanel,
  setOpenNotificationPanel,
  notificationList,
  setNotificationList,
  handleLoadMore,
}: NotificationPanelProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleClose() {
    setOpenNotificationPanel(!openNotificationPanel);
  }

  function handleClickAway() {
    setOpenNotificationPanel(false);
  }

  const markAsRead = async (notification: any) => {
    try {
      const updatedNotifications = notificationList?.values?.map((n: any) =>
        n.id === notification.id
          ? { ...n, is_read: n.is_read === 0 ? 1 : 0 }
          : n
      );

      setNotificationList({
        ...notificationList,
        values: updatedNotifications,
        total_unread: notification.is_read
          ? ++notificationList.total_unread
          : --notificationList.total_unread,
      });
      updateNotificationStatus(notification.id);
    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };

  return (
    <>
      <ClickAwayListener onClickAway={handleClickAway}>
        <StyledPaper>
          <StyledNoHoverMenuItem sx={{ cursor: "auto" }}>
            <b>Notifications</b>
          </StyledNoHoverMenuItem>
          <Divider style={{ margin: "0px" }} />
          <MenuList style={{ padding: "0px" }}>
            {notificationList.values.map((notification: any) => (
              <Fragment>
                {notification.is_read === 0 && (
                  <MenuItem sx={{ cursor: "pointer" }}>
                    <StyledAvatar src={notification.socialAvatarUrl} />
                    <StyledText style={{ fontWeight: "bold" }}>
                      {notification.memo_title}
                    </StyledText>
                    <CircleWrapper onClick={() => markAsRead(notification)}>
                      <NotificationCircle />
                    </CircleWrapper>
                  </MenuItem>
                )}
                {notification.is_read !== 0 && (
                  <MenuItem sx={{ cursor: "pointer" }}>
                    <StyledAvatar src={notification.socialAvatarUrl} />
                    <StyledText>{notification.memo_title}</StyledText>
                    <CircleWrapper onClick={() => markAsRead(notification)}>
                      <NotificationCircle color="#B2B2B2" />
                    </CircleWrapper>
                  </MenuItem>
                )}
                <Divider style={{ margin: "0px" }} />
              </Fragment>
            ))}
          </MenuList>

          {notificationList.total === 0 && (
            <MenuItem sx={{ cursor: "auto" }}>
              <StyledText style={{ fontSize: "0.85rem" }}>
                You don't have any notifications yet.
              </StyledText>
            </MenuItem>
          )}

          {notificationList.sum < notificationList.total && (
            <MenuItem className="compact" sx={{ cursor: "auto" }}>
              <StyledButton onClick={handleLoadMore}>
                See previous notifications
              </StyledButton>
            </MenuItem>
          )}
        </StyledPaper>
      </ClickAwayListener>
    </>
  );
}
